"use client";

import { DISCORD_INVITE_URL, TWITTER_URL } from "@cede/utils";
import Image from "next/image";

export function MaintenancePage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[var(--color-mobile-background)] p-6 sm:bg-[var(--color-mobile-background)]">
      <div className="flex max-w-[500px] flex-col items-center gap-8">
        {/* Cede Hub Logo */}
        <Image src="/favicon.svg" alt="Cede Hub" width={120} height={120} unoptimized />

        {/* Maintenance Message */}
        <h5 className="h5 text-center font-medium leading-relaxed text-cede-text-primary">
          We're currently performing scheduled maintenance to improve your experience.
        </h5>

        {/* Reassurance */}
        <p className="body1 text-center leading-relaxed text-cede-text-secondary">
          Don't worry - your funds and data are safe. The platform will be back online shortly.
        </p>

        {/* Discord Link */}
        <p className="body2 text-center text-cede-text-secondary">
          Questions? Join our{" "}
          <a
            href={DISCORD_INVITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-cede-primary no-underline hover:underline"
          >
            Discord
          </a>{" "}
          or{" "}
          <a
            href={TWITTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-cede-primary no-underline hover:underline"
          >
            X
          </a>{" "}
          for real-time updates.
        </p>
      </div>
    </div>
  );
}
